import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { inject } from '@ember/service';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#each this.args.item.addresses as |address|}}\n  <div class=\'grid-x grid-padding-x box-white address-wrap\'>\n    <div class=\'cell auto\'>\n      <EditSingleAddress\n        @applicationController={{this.args.applicationController}}\n        @item={{address}}\n        @required={{this.args.required}}\n        @addresses={{this.args.item.addresses}}\n      />\n    </div>\n  </div>\n{{/each}}\n\n{{#if this.showAddNew}}\n  <p>\n    <button\n      type=\'button\'\n      class=\'button expanded\'\n      data-test-add-related\n      {{on \'click\' this.addRelated}}\n    >\n      {{t \'add address\'}}\n    </button>\n  </p>\n{{/if}}");

var _class, _descriptor;
const ADDRESS_CONTENT_FIELDS = ['name', 'location_address_text', 'location_address_house', 'location_address_street', 'location_address_postal_code', 'location_address_city', 'location_address_county', 'location_address_state', 'location_address_country_code', 'notes', 'piano', 'location_position_lat', 'location_position_lng'];
let RelatedAddressesComponent = (_class = class RelatedAddressesComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  get showAddNew() {
    const addresses = this.args.item?.addresses;
    const maxAddress = this.args.maxAddress;
    return addresses && (maxAddress == null || addresses.length < maxAddress);
  }
  willDestroy() {
    super.willDestroy(...arguments);
    // Scarica gli indirizzi nuovi (isNew) lasciati vuoti dall'utente: senza
    // questo, saveAll li serializzerebbe al prossimo salvataggio del contact
    // creando indirizzi vuoti orfani nel backend.
    const addresses = this.args.item?.addresses;
    if (!addresses) return;
    addresses.slice().forEach(a => {
      if (a?.isNew && !this._hasContent(a)) {
        const _i = addresses.indexOf(a);
        if (_i !== -1) {
          addresses.splice(_i, 1);
        }
        a.unloadRecord();
      }
    });
  }
  _hasContent(address) {
    return ADDRESS_CONTENT_FIELDS.some(field => {
      const value = address.get(field);
      return value !== null && value !== undefined && value !== '';
    });
  }
  addRelated() {
    const addresses = this.args.item.addresses;
    const hasInvoice = addresses.find(a => !!a.is_invoice);
    const newAddress = this.store.createRecord('address', {
      is_invoice: !hasInvoice
    });
    addresses.push(newAddress);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addRelated"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, RelatedAddressesComponent);

export { RelatedAddressesComponent as default };
//# sourceMappingURL=related-addresses.js.map
